"use client";

import ShoppingBag from "@mui/icons-material/ShoppingBag"; // Local CUSTOM COMPONENTS
import { Fragment } from "react";

import { useRouter, useSearchParams } from "next/navigation";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import DashboardHeader from "../../dashboard-header"; // CUSTOM DATA MODEL
import Pagination from "../../pagination";
import OrderRow from "../order-row";

// ====================================================
const OrdersPageView = (props) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const paging = SalifyFallback.useSelect("output:orders.paging");
  const orders = SalifyFallback.useSelect("output:orders.data");
  const currentPage = +(searchParams?.get("page") ?? 1);

  const onChangePage = (event, newPage) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newPage === 1 ? newSearchParams.delete("page") : newSearchParams.set("page", String(newPage));
    if (newPage !== currentPage) {
      router.push("?" + newSearchParams.toString());
    }
  };

  return (
    <Fragment>
      {/* TITLE HEADER AREA */}
      <SalifyFallback.Label
        path="My Orders"
        default="Đơn hàng của tôi"
        render={(label) => <DashboardHeader Icon={ShoppingBag} title={label} />}
      />

      {/* ORDER LIST AREA */}
      {orders.map((order) => (
        <OrderRow order={order} key={order.id} />
      ))}

      {/* ORDERS PAGINATION */}
      <Pagination
        count={Math.ceil((paging.total || 0) / 5)}
        defaultPage={currentPage}
        onChange={onChangePage}
      />
    </Fragment>
  );
};

export default OrdersPageView;
